











































































































































































































import {
  defineComponent, reactive, computed, watch, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import { useResult, useQuery, useMutation } from '@vue/apollo-composable';

import log from '@/table/log';

import GroupAddressEditor from '@/components/GroupAddressEditor.vue';
import ViewOnlyGuard from '@/components/ViewOnlyGuard.vue';
import CommonDropzoneWithImageUpload from '@/components/CommonDropzoneWithImageUpload.vue';
import CommonLearningCenterTypeSelector from '@/components/Selector/CommonLearningCenterTypeSelector.vue';
import CommonGeolocationInput from '@/components/CommonInput/CommonGeolocationInput.vue';
import CommonMultiCreatorsSelector from '@/components/Selector/CommonMultiCreatorsSelector.vue';
import CommonTagsMultiSelector from '@/components/Selector/CommonTagsMultiSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonImageTable from '@/components/Table/CommonImageTable.vue';

import getLearningCenter from '@/gql/getLearningCenter.gql';
import createLearningCenter from '@/gql/createLearningCenter.gql';
import updateLearningCenter from '@/gql/updateLearningCenter.gql';

const LearningCenterEditor = defineComponent({
  setup() {
    /* ==== Get meta data ==== */
    const { route } = useRouter();
    // eslint-disable-next-line
    const mode = route.value.meta.mode;
    const modeDisplay = computed(() => {
      if (mode === 'create') return 'เพิ่ม';
      if (mode === 'edit') return 'แก้ไข';
      if (mode === 'view') return 'ดู';
      return '';
    });
    // Try to destructor but doesn't work Q^Q

    /* ===== Menu manager ===== */
    const editorMenu = [
      { id: 0, status: true, display: 'ประเภทแหล่งเรียนรู้' },
      { id: 1, status: false, display: 'ข้อมูลทั่วไปและที่อยู่' },
      { id: 2, status: false, display: 'ข้อมูลติดต่อและการเดินทาง' },
      { id: 3, status: false, display: 'ข้อมูลประวัติและแนวคิด' },
      { id: 4, status: false, display: 'ภาพประกอบ' },
      { id: 5, status: false, display: 'แผนผัง' },
      { id: 6, status: false, display: 'ผู้สร้างสรรค์ผลงานในพื้นที่' },
      { id: 7, status: false, display: 'ประวัติการแก้ไข' },
    ];
    function changeActiveMenu(index: number) {
      for (let i = 0; i < editorMenu.length; i += 1) {
        if (editorMenu[index].id === i) editorMenu[i].status = true;
        else editorMenu[i].status = false;
      }
    }
    // ============================================= //

    // This function use with Creator multiselector  //
    function transformCreatorToLibFormat(arr: { firstName: string; lastName: string; id: number }[]) {
      if (!arr) return [];
      const temp: any = [];
      arr.forEach((element) => {
        temp.push(`${element.firstName} ${element.lastName} value: ${element.id}`);
      });
      return temp;
    }
    // ============================================ //

    /* ===== Form ===== */
    const form = reactive({
      type: '',
      name: '',
      title: '',
      // lastUpdatedBy: '',
      logs: [],
      // ประเภท
      address: {
        province: {
          id: '',
          name: '',
        },
        postcode: '',
        district: {
          id: '',
          name: '',
        },
        amphur: {
          id: '',
          name: '',
        },
        address: '',
      },
      // ข้อมูลทั่วไป
      area: '',
      geolocation: {
        lat: '',
        long: '',
      },
      geolocationText: '',
      website: '',
      // ข้อมูลติดต่อ
      contactName: '',
      contactTelephone: '',
      openingHour: '',
      direction: '',
      // ข้อมูลประวัติ
      background: '',
      objective: '',
      concept: '',
      aboutMember: '',
      product: '',
      facility: '',
      description: '',
      tags: [],
      // ภาพประกอบ
      images: [],
      // แผนผัง
      floorPlans: [],
      // ผู้สร้างสรรค์ผลงานในพื้นที่
      creators: [],
      // ช่วยในการ display
      active: false,
    });

    /* ==== Validate to submit button ==== */
    const validated = computed(() => {
      if (form.type === '' || form.type === undefined) return false;
      if (form.name === '' || form.name === undefined) return false;
      // if (form.address.province.id === '' || form.address.province.id === undefined) return false;
      return true;
    });

    const saveModal = ref(null);
    function pendingSubmit() {
      if (validated.value) (saveModal.value as any).open();
    }
    // ========================= //

    /* ==== Get value when enter edit mode */
    const isQueryEnabled = ref(true);
    const { result: learningCenterResult } = useQuery(getLearningCenter, computed(() => ({
      id: route.value.params.learningCenterId,
    })), () => ({
      fetchPolicy: 'network-only',
      enabled: isQueryEnabled.value,
    }));
    watch(learningCenterResult, () => {
      const learningCenter = useResult(learningCenterResult, null, (data) => data.learningCenter);
      const item = learningCenter.value;
      if (item) isQueryEnabled.value = false; // if value is loaded, disable next query
      form.type = item?.learningCenterType?.id || '';
      form.name = item?.name || '';
      form.title = item?.title || '';
      // ======================= //
      form.aboutMember = item?.aboutMember || '';
      form.background = item?.background || '';
      form.facility = item?.facility || '';
      form.product = item?.product || '';
      form.objective = item?.objective || '';
      form.concept = item?.concept || '';
      form.description = item?.description || '';
      // ======================= //
      form.openingHour = item?.openingHour || '';
      form.tags = item?.tags || [];
      form.website = item?.website || '';
      form.area = item?.area || '';
      form.contactName = item?.contactName || '';
      form.contactTelephone = item?.contactTelephone || '';
      form.direction = item?.direction || '';
      // ==== Address Group ==== //
      form.address.province.id = item?.groupAddress.province?.id;
      form.address.amphur.id = item?.groupAddress.amphur?.id;
      form.address.district.id = item?.groupAddress.district?.id;
      form.address.postcode = item?.groupAddress.postcode;
      form.address.address = item?.groupAddress?.address;
      form.geolocationText = `${item?.geolocation.lat ? `${item?.geolocation.lat}, ` : ''}${item?.geolocation.long ? item?.geolocation.long : ''}`;
      // ===== Images ==== //
      form.images = item?.images || [];
      // ===== FloorPlans ==== //
      form.floorPlans = item?.floorPlans || [];
      // ==== Logs ==== //
      form.logs = item?.logs;
      // ==== Creators ==== //
      form.creators = transformCreatorToLibFormat(item?.creators);
    });

    const computedGeolocation = computed(() => {
      const text = form.geolocationText?.split(', ');
      if (!text) return { lat: 0.00, long: 0.00 };
      return {
        lat: parseFloat(text[0]),
        long: parseFloat(text[1]),
      };
    });

    const computedImages = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.images?.forEach((element: any) => {
        temp.push(parseInt(element.id, 10));
      });
      return temp;
    });

    const computedfloorPlans = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.floorPlans?.forEach((element: any) => {
        temp.push(parseInt(element.id, 10));
      });
      return temp;
    });

    const computedCreators = computed(() => {
      const temp: any = [];
      form.creators.forEach((element: any) => {
        temp.push(parseInt(element.split(' value: ')[1], 10));
      });
      return temp;
    });

    const learningCenterInput = computed(() => ({
      learningCenterType: parseInt(form.type, 10) || '',
      name: form.name || '',
      area: form.area || '',
      website: form.website || '',
      contactName: form.contactName || '',
      contactTelephone: form.contactTelephone || '',
      openingHour: form.openingHour || '',
      direction: form.direction || '',
      background: form.background || '',
      objective: form.objective || '',
      concept: form.concept || '',
      aboutMember: form.aboutMember || '',
      product: form.product || '',
      facility: form.facility || '',
      active: true,
      tags: form.tags || [],
      images: computedImages.value,
      floorPlans: computedfloorPlans.value,
      geolocation: computedGeolocation.value,
      groupAddress: {
        address: form.address.address || '',
        district: parseInt(form.address.district.id, 10) || null,
        amphur: parseInt(form.address.amphur.id, 10) || null,
        province: parseInt(form.address.province.id, 10) || null,
        postcode: form.address.postcode || '',
      },
      creators: computedCreators.value,
    }));

    // ===== Create Mutation =====
    const createLearningCenterMutation = useMutation(createLearningCenter,
      () => ({
        variables: {
          input: learningCenterInput.value,
        },
        refetchQueries: ['getLearningCenters', 'getLearningCenterTypes'],
      }));
    // ========================= //

    // ===== Update Mutation =====
    const updateLearningCenterMutation = useMutation(updateLearningCenter,
      () => ({
        variables: {
          id: route.value.params.learningCenterId,
          input: learningCenterInput.value,
        },
        refetchQueries: ['getLearningCenters', 'getLearningCenterTypes'],
      }));
    // ========================= //

    // ==== Computed Mutation ==== //
    const computedMutation = computed(() => {
      if (mode === 'create') return createLearningCenterMutation;
      return updateLearningCenterMutation;
    });

    function onImageUploadDone(newImage: never) {
      if (!form.images) form.images = [];
      form.images.push(newImage);
    }

    function onFloorPlanUploadDone(newImage: never) {
      if (!form.floorPlans) form.floorPlans = [];
      form.floorPlans.push(newImage);
    }

    return {
      onImageUploadDone,
      onFloorPlanUploadDone,
      mode,
      modeDisplay,
      editorMenu,
      changeActiveMenu,
      form,
      log,
      computedMutation,
      validated,
      pendingSubmit,
      saveModal,
    };
  },
  components: {
    GroupAddressEditor,
    ViewOnlyGuard,
    CommonImageTable,
    CommonDropzoneWithImageUpload,
    CommonMultiCreatorsSelector,
    CommonLearningCenterTypeSelector,
    CommonGeolocationInput,
    CommonTagsMultiSelector,
    CommonConfirmDialog,
  },
  props: {
    role: {},
  },
});

export default LearningCenterEditor;
